interface DashboardPageLayoutProps {
  children: React.ReactNode;
}

export default function DashboardPageLayout({ children }: DashboardPageLayoutProps) {
  return (
    <div className="flex w-full h-fit flex-col items-start gap-8 px-14 pt-6 shrink-0">
      {children}
    </div>
  );
}

interface RoadmapSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  /** Card width/flex classes — the IO/NF approved dashboard uses "w-full h-fit". */
  sizingClassName?: string;
  /** Omit the <h3> title (IO/NF approved dashboard has none). */
  hideTitle?: boolean;
  /** Rendered inside the card, between the title and the cards. */
  header?: React.ReactNode;
}

export function RoadmapSection({
  title,
  children,
  className,
  sizingClassName = "flex-1 min-w-0",
  hideTitle,
  header,
}: RoadmapSectionProps) {
  return (
    <div className={`flex flex-col items-start gap-6 self-stretch rounded-lg border border-cSage bg-white p-10 ${sizingClassName} ${className || ""}`}>
      {!hideTitle && <h3>{title}</h3>}
      {header}
      <div className="flex w-full flex-col gap-8">
        {children}
      </div>
    </div>
  );
}

interface NextStepSectionProps {
  children: React.ReactNode;
}

export function NextStepSection({ children }: NextStepSectionProps) {
  return (
    <div className="flex flex-col items-start gap-6 ml-8">
      {children}
    </div>
  );
}
